/**
 * Dependencies.
 */
import { BaseModel, endpoint, prop } from '@prz-dp/services';

/**
 * Export model `OwnerModel`.
 */
@endpoint('partnerships/owners')
export class OwnerModel extends BaseModel {
  /**
   * Properties.
   */
  @prop()
  id: number;

  @prop()
  name: string;

  /**
   * Constructor.
   */
  constructor(data?: Partial<OwnerModel>) {
    super(data);
  }
}
